import React, { useCallback, useEffect, useState } from 'react';

import { myInvoiceIcon } from '@europrocurement/l2d-icons';
import { useNavigate } from 'react-router';
import { mediaObjectFiltersToElasticQuery, useAchatsService } from '@europrocurement/l2d-domain';
import { WidgetWithAction } from '@europrocurement/l2d-modules';
import achatsViewPathResolver from '../../../../Achats/achatsViewPathResolver';

// interne

const FacturesInternesNonAttribuees: React.FunctionComponent = function () {
    const navigate = useNavigate();

    const { mediaObjectApi } = useAchatsService();

    const [countOfUnassignedUnregisteredInvoices, setCountOfUnassignedUnregisteredInvoices] =
        useState<string>();

    const fetchCount = useCallback(() => {
        mediaObjectApi
            .listMediaObjectMediaObjectCollection(
                mediaObjectFiltersToElasticQuery({
                    search: '',
                    pagination: {
                        page: 0,
                        itemsPerPage: 0,
                    },
                    filters: {
                        createdBy: 'service-account-api-formalite',
                        forceInterne: true,
                        dateDebutTraitementBefore: new Date(new Date().getTime() - 2 * 60 * 1000),
                        available: true,
                        deleted: false,
                    },
                    orders: [],
                    xIdSociete: 12,
                }),
            )
            .then((res) => {
                if (
                    res.data['hydra:totalItems'] !== null ||
                    res.data['hydra:totalItems'] !== undefined
                ) {
                    setCountOfUnassignedUnregisteredInvoices(`${res.data['hydra:totalItems']}`);
                }
            });
    }, [mediaObjectApi]);

    useEffect(() => {
        fetchCount();
    }, [fetchCount]);

    const actionCallback = useCallback(async () => {
        navigate(
            `${achatsViewPathResolver('listmediaobjectinternally')}?tab=Factures+non+attribuées`,
        );
    }, [navigate]);

    return (
        <WidgetWithAction
            title="Factures internes non attribuées"
            icon={myInvoiceIcon}
            actionMessage="Traiter"
            actionCallback={actionCallback}
            data={countOfUnassignedUnregisteredInvoices}
            color="purple"
            onRetryData={fetchCount}
        />
    );
};

export default FacturesInternesNonAttribuees;
